<template>
  <v-sheet v-if="about.title" color="grey lighten-1 about-section">
    <div class="py-0 py-sm-5 py-lg-16 position-relative">
      <v-container>
        <v-row no-gutters align="center">
          <v-col
            class="pt-6"
            v-if="
              about.imgs &&
              about.imgs.featured &&
              about.imgs.featured.path &&
              smAndDown
            "
            cols="12"
          >
            <div
              v-if="smAndDown"
              class="d-flex justify-md-start justify-center mb-5"
            >
              <TitleWidget>{{ about.title }}</TitleWidget>
            </div>
            <img
              width="100%"
              class="d-block"
              :src="files + about.imgs.featured.path"
              alt=""
            />
          </v-col>
          <v-col cols="12" md="6">
            <div
              v-if="!smAndDown"
              class="d-flex justify-md-start justify-center"
            >
              <TitleWidget>{{ about.title }}</TitleWidget>
            </div>
            <div
              class="
                text-body-2
                grey--text
                text--lighten-2
                ck-content
                mt-4
                text-center text-sm-start
              "
              v-html="about.intro"
            ></div>
            <div class="mt-12 d-flex justify-center justify-sm-start">
              <v-btn
                to="/quem-somos"
                rounded
                height="48px"
                depressed
                class="primary px-12 py-3"
              >
                Saiba Mais
              </v-btn>
            </div>
          </v-col>

          <div
            v-if="
              about.imgs &&
              about.imgs.featured &&
              about.imgs.featured.path &&
              !smAndDown
            "
            class="about-img"
          >
            <div
              class="about-img-item"
              :style="`background-image: url(${
                files + about.imgs.featured.path + '?resize=1&h=600'
              });`"
            ></div>

            <div class="d-flex align-end about-before">
              <img
                class="d-block"
                src="../../assets/img/about-before.svg"
                width="100%"
              />
            </div>
          </div>
        </v-row>
      </v-container>
    </div>
  </v-sheet>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
const _config = {
  mod: "about",
};

export default {
  components: { TitleWidget },
  computed: {
    about() {
      return this.$rest(_config.mod).item;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  mounted() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
};
</script>

<style lang="scss" scoped>
.about-section {
  padding-top: 100px;
  padding-bottom: 100px;
  @media (max-width: 960px) {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}
.about-img {
  height: 100%;
  width: 50%;
  position: absolute;
  right: 0;
  top: 0;

  .about-before {
    pointer-events: none;
    z-index: 1;
    width: 111%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;

    img {
      transform: translateY(55%);
    }
  }

  &-item {
    background-position-x: 50%;
    height: 100%;
    width: 100%;
    clip-path: polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%);
    position: relative;
  }
}
</style>
